import { render, staticRenderFns } from "./commonFinishPaper.vue?vue&type=template&id=7d4aff32&scoped=true&"
import script from "./commonFinishPaper.vue?vue&type=script&lang=js&"
export * from "./commonFinishPaper.vue?vue&type=script&lang=js&"
import style0 from "./commonFinishPaper.vue?vue&type=style&index=0&id=7d4aff32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4aff32",
  null
  
)

export default component.exports